<template>
	<div
		class="row mb-lg-3 mt-lg-1 d-flex flex-column flex-md-row"
		:class="centralizeButtonNL"
	>
		<div
			v-if="!this.isLocaleNL"
			class="col-12 col-md-6 d-flex align-items-center justify-content-center mb-2"
		>
			<button
				@click.stop="handleReserveClick('ask_quote')"
				class="button-secondary bg-none border-primary-blue text-primary-blue d-flex align-items-center justify-content-center w-100"
			>
				<span class="buttons-default">{{
					content.planner_resumeCreateQuote
				}}</span>
			</button>
		</div>
		<div
			class="col-12 col-md-6 d-flex align-items-center justify-content-center mb-2"
		>
			<button
				@click.stop="handleReserveClick('book')"
				class="button-primary primary-normal cursor-pointer d-flex align-items-center justify-content-center w-100"
			>
				<span class="buttons-default">{{ content.planner_resumeOrder }}</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import store from "@/vue/planning/store/store"

// Tracking
import trackReservationClick from "@/tracking/trackReservationClick"
import getReservationClickData from "@/tracking/logic/getReservationClickData"

export default {
	store,
	name: "BotomButtons",
	computed: {
		...mapState(["content"]),
		...mapGetters([
			"bookingProcessURL",
			"totalSelectedHebergements",
			"isFewerParticipantsThanSelectedMaxCapacity",
			"isLocaleNL",
		]),
		centralizeButtonNL() {
			return { "justify-content-center": this.isLocaleNL }
		},
	},
	methods: {
		handleReserveClick(eventName) {
			this.$store.dispatch("reserveClick")
			const {
				quantity,
				liheId,
				liheName,
				duration,
				beginDate,
				endDate,
				prestationsIds,
				prestationsNames,
				totalPrice,
				station,
				region,
			} = getReservationClickData()
			trackReservationClick(
				eventName,
				quantity,
				prestationsIds,
				prestationsNames,
				totalPrice,
				beginDate,
				endDate,
				duration,
				liheId,
				liheName,
				station,
				region
			)
		},
	},
}
</script>

<style scoped>
.planning-bottom-btn {
	transition: background 150ms ease-in-out, box-shadow 150ms ease-in-out;
}

.planning-bottom-btn.white {
	background: white;
}
.planning-bottom-btn.blue {
	background: #52b3d8;
}

.planning-bottom-btn.white:hover {
	box-shadow: 0px 0px 0px 1px #52b3d8;
}
.planning-bottom-btn.blue:hover {
	background: #3fa6cd;
}
</style>
